<template>
  <div class="forget-modal">
    <div
      v-if="user.isForgetActive"
      class="popup-wrap popup-login popup-forget"
      :class="{ active: user.isForgetActive }"
    >
      <div class="popup-box">
        <a class="popup-close" @click="deactivatePopup" />
        <i class="content-left login-bg-left" />
        <div class="content forget-con">
          <div class="form-wrap">
            <div class="mb-bn">
              <img :src="getThemeImagePath('login-logo-2-mb.jpg')" alt="">
            </div>
            <h5>{{ $t("Bao.forget_password") }}</h5>
            <span>{{ $t('Bao.registered_account_require') }}</span>
            <div class="form-input" :class="{ 'form-input-error-1': errors.has('username') }">
              <input
                v-model="postForm.username"
                v-validate="'required'"
                type="text"
                name="username"
                :data-vv-as="$t('Bao.username')"
                :placeholder="$t('Bao.registered_account')"
                :required="true"
                autocomplete="off"
              >
            </div>
            <div v-if="errors.has('username')" class="help-block pull-right">
              {{ $t("Bao.user_name_error") }}
            </div>
            <template v-if="type === 1">
              <label for="eMail" class="forget-input-title"> {{ $t('Bao.registered_email_require') }} </label>
              <div class="col-input d-flex mailGrouo mb-3">
                <input
                  id="eMail"
                  v-model="postForm.email"
                  v-validate="'required'"
                  class="form-control col"
                  type="text"
                  name="check_email"
                  autocomplete="off"
                  :placeholder="$t('Bao.registered_email')"
                >
                <span class="at-sign fs-5 mx-2 align-center">@</span>
                <select
                  id="plan"
                  v-model="selectedDomain"
                  name="plan"
                  class="MailDropdown ml-drop col"
                >
                  <option value="none" selected="" disabled="" hidden="">
                    {{ $t("Bao.select_domain") }}
                  </option>
                  <option value="gmail.com">
                    gmail.com
                  </option>
                  <option value="yahoo.com">
                    yahoo.com
                  </option>
                  <option value="yahoo.co.jp">
                    yahoo.co.jp
                  </option>
                  <option value="hotmail.com">
                    hotmail.com
                  </option>
                  <option value="hotmail.co.jp">
                    hotmail.co.jp
                  </option>
                  <option value="outlook.com">
                    outlook.com
                  </option>
                  <option value="outlook.jp">
                    outlook.jp
                  </option>
                  <option value="msn.com">
                    msn.com
                  </option>
                  <option value="live.jp">
                    live.jp
                  </option>
                </select>
              </div>
              <div v-if="errors.has('check_email')" class="help-block pull-right">
                {{ $t("Bao.email_error") }}
              </div>
            </template>
            <label
              v-if="registerNeedPhone"
              for="phoneNumber"
              class="forget-input-title"
            >{{ $t("Bao.phone") }}</label>
            <div class="phone-group mb-3">
              <div class="form-select-1">
                <div class="form-select-value">
                  <img :src="getThemeImagePath('japan.png')" alt="">
                </div>
              </div>
              <input
                id="phoneNumber"
                v-model="postForm.phone"
                class="input-phone form-control cou-input"
                type="text"
                :placeholder="$t('Bao.forget_password_phone')"
                @input="onlyNumbers"
              >
            </div>

            <div class="form-agree">
              <div class="form-button">
                <button
                  class="button-style-7"
                  type="button"
                  :disabled="isSendButtonDisabled"
                  @click="submit"
                >
                  <span>{{ $t("Bao.send") }}</span>
                </button>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>

    <!-- 手機驗證彈窗 -->
    <div
      v-if="registerNeedPhone && isVerify"
      class="popup-wrap popup-register-email"
      :class="{ active: isVerify }"
    >
      <div class="popup-box">
        <a class="popup-close" href="javascript:;" @click="closeVerify('verify')" />
        <div class="form-popup">
          <div class="inner">
            <p class="h4">
              <span>
                {{ $t("Bao.verify_phone") }}
              </span>
            </p>
            <p class="h5">
              <span>
                {{ $t("Bao.verify_phone_code") }}
              </span>
            </p>
            <div class="verify-input">
              <input
                v-model="postForm.validate_code"
                class="modal_register_ipt bg-white border-0"
                type="text"
                name="phoneValidateCode"
                autocomplete="off"
              >
              <button class="button-style-7" :disabled="isPhoneButtonDisabled" @click="getVerificationPop">
                <span>{{ $t("Bao.verify_register") }}</span>
              </button>
            </div>
            <p class="email-notice">
              <i>
                <img :src="getThemeImagePath('icon-detail.png')" alt="">
              </i>{{ $t("Bao.email_notice_4") }}
              <span>{{ $t("Bao.phone_notice_5") }}</span>
            </p>
            <p>
              {{ $t("Bao.email_notice_1") }}
              <br>
              <span>
                {{ $t("Bao.phone_notice_3") }}
              </span>
            </p>
            <div class="verify-button">
              <button class="button-style-15" :disabled="timerCount" @click="getCode">
                <span>{{ timerCount ? '(' + limitSecond + 's)' : $t('Bao.get_verification_code') }}</span>
              </button>
              <button class="button-style-15" @click="changePhone">
                <span>
                  {{ $t("Bao.phone_change") }}
                </span>
              </button>
            </div>
          </div>
        </div>
      </div>
    </div>

    <!-- phone 設定新密碼 -->
    <div
      v-if="limitVerify || isUpdatePassSuccess"
      class="popup-wrap popup-check"
      :class="{ active: limitVerify || isUpdatePassSuccess }"
    >
      <div class="popup-box">
        <a class="popup-close" @click="closeVerify('setting')" />
        <div class="content">
          <div v-show="user.isResetPasswordActive && limitVerify" class="form-wrap form-check">
            <h4 class="text-center fw-bold mb-3">
              {{ $t("Bao.set_new_pass_1") }}
            </h4>
            <p class="text-center text-black-50 mb-5">
              {{ $t("Bao.set_new_pass_2") }}
            </p>

            <div class="form-input mb-4">
              <input
                ref="new_pass"
                v-model="postForm.new_password"
                type="password"
                name="new_pass"
                :placeholder="$t('Bao.set_new_pass_3')"
                @input="checkPassErrors"
              >
              <div v-for="error in passErrors" :key="error" class="help-block pull-right">
                {{ error }}
              </div>
            </div>

            <div class="form-input">
              <input
                v-model="postForm.confirmPassword"
                v-validate="'required|confirmed:new_pass'"
                type="password"
                :placeholder="$t('Bao.set_new_pass_4')"
                name="confirm_pass"
              >
              <div v-if="errors.has('confirm_pass')" class="help-block pull-right">
                {{ $t("Bao.new_password_error") }}
              </div>
            </div>

            <div class="form-agree">
              <div class="form-button">
                <button
                  class="button-style-7 btn-send"
                  :disabled="updatePassBtn"
                  @click="handleUpdatePhone"
                >
                  <span>{{ $t("Bao.send") }}</span>
                </button>
              </div>
            </div>
          </div>

          <!--  phone 密碼重新設定成功 -->
          <div
            v-if="isUpdatePassSuccess"
            class="form-wrap form-check-done"
            :class="{ 'D-none': !isUpdatePassSuccess }"
          >
            <svg class="mb-3" width="120" height="120" viewBox="0 0 120 120" fill="none">
              <path d="M60 5C49.122 5 38.4883 8.22569 29.4436 14.2692C20.3989 20.3126 13.3494 28.9025 9.18662 38.9524C5.0238 49.0023 3.93462 60.061 6.0568 70.73C8.17899 81.3989 13.4172 91.199 21.1091 98.8909C28.801 106.583 38.6011 111.821 49.27 113.943C59.939 116.065 70.9976 114.976 81.0476 110.813C91.0975 106.651 99.6873 99.6011 105.731 90.5564C111.774 81.5117 115 70.878 115 60C115 45.4131 109.205 31.4236 98.8909 21.1091C88.5764 10.7946 74.5869 5 60 5ZM88.535 48.535L53.535 83.535C52.5974 84.4724 51.3258 84.9989 50 84.9989C48.6742 84.9989 47.4026 84.4724 46.465 83.535L31.465 68.535C30.5542 67.592 30.0502 66.329 30.0616 65.018C30.073 63.707 30.5989 62.4529 31.5259 61.5259C32.4529 60.5989 33.707 60.073 35.018 60.0616C36.329 60.0502 37.592 60.5542 38.535 61.465L50 72.93L81.465 41.465C82.408 40.5542 83.671 40.0502 84.982 40.0616C86.293 40.073 87.547 40.5989 88.4741 41.5259C89.4011 42.4529 89.927 43.707 89.9384 45.018C89.9498 46.329 89.4458 47.592 88.535 48.535Z" fill="#978564" />
            </svg>
            <h4 class="text-center fw-bold mb-2">
              {{ $t("Bao.set_new_pass_success_1") }}
            </h4>
            <p class="text-center text-black-50 mb-5">
              {{ $t("Bao.set_new_pass_success_2") }}
            </p>

            <div class="form-agree" @click="goHome">
              <div class="form-button">
                <button class="button-style-7">
                  <span>{{ $t("Bao.set_new_pass_success_3") }}</span>
                </button>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>

import { requestForgotPassword, validateCodInfo, forgotPassword } from '@/api/user'
import { setErrorMessage, showNotice, getThemeImagePath } from '@/utils/tool'

export default {
  name: 'Forget',

  data() {
    const postForm = {
      username: '',
      email: '',
      completeEmail: '',
      phone: '',
      validate_code: '',
      new_password: '',
      confirmPassword: ''
    }

    return {
      actionLoading: false,
      postForm,
      limitVerify: false,
      limitSecond: 180,
      isVerify: false,
      isFlagShow: false,
      selectedDomain: 'none',
      type: 1, // 1: email, 2: phone
      timerCount: true,
      isUpdatePassSuccess: false,
      currentTimerId: null,
      passErrors: [' ']
    }
  },
  computed: {
    user() {
      return this.$store.state.user
    },
    registerNeedPhone() {
      return this.$store.state.brand.permissionInfo.register_need_phone
    },
    isSendButtonDisabled() {
      const usernameValidate = this.postForm.username === null || this.postForm.username.trim() === ''
      if (this.type === 1) {
        /* eslint-disable no-unused-vars */
        const { email, username, ...rest } = this.postForm
        const formToCheck = { email, username }
        const hasEmptyFields = Object.values(formToCheck).some(value => value === null || value === '')
        const emailValidate = this.postForm.email === null || this.postForm.email.trim() === ''
        return usernameValidate || emailValidate || this.actionLoading || hasEmptyFields || this.selectedDomain === 'none'
      } else {
        const { username, phone, ...rest } = this.postForm
        const formToCheck = { phone, username }
        const hasEmptyFields = Object.values(formToCheck).some(value => value === null || value === '')
        const phoneValidate = this.postForm.phone === null || this.postForm.phone.trim() === ''
        return usernameValidate || phoneValidate || this.actionLoading || hasEmptyFields
      }
    },
    isPhoneButtonDisabled() {
      return this.postForm.validate_code === null || this.postForm.validate_code.trim() === ''
    },
    updatePassBtn() {
      const hasErrors = this.errors.any()
      /* eslint-disable no-unused-vars */
      const { username, email, completeEmail, phone, validate_code, ...formToCheck } = this.postForm

      const hasEmptyFields = Object.values(formToCheck).some(value => value === null || value === '')
      return hasErrors || hasEmptyFields || this.passErrors.length > 0
    }
  },
  watch: {
    'postForm.email'(newValue) {
      if (this.type === 1) {
        this.updateCompleteEmail()
      }
    },
    selectedDomain(newValue) {
      if (this.type === 1) {
        this.updateCompleteEmail()
      }
    }
  },
  created() {
    this.initPostForm()
    if (this.registerNeedPhone) {
      this.type = 2
    }
  },
  methods: {
    submit() {
      if (this.type === 1) {
        this.handleUpdateEmail()
      } else {
        this.openPhoneVerify()
      }
    },
    handleUpdateEmail() {
      const self = this
      this.actionLoading = true
      const email = this.postForm.email
      this.postForm.email = this.postForm.completeEmail
      requestForgotPassword(this.postForm).then(response => {
        this.initPostForm()
        this.limitVerify = false
        showNotice(this.$t('Bao.send_email_success'), function() {
          self.$store.commit('SET_FORGET_OPEN', false)
        }, true, false, '')
      }).catch((error) => {
        if (this.postForm.email.includes('@')) {
          this.postForm.email = email
        }

        setErrorMessage(error.response, this.errors)
      }).finally((e) => {
        this.actionLoading = false
      })
    },
    openPhoneVerify() {
      this.getCode()
    },
    getCode() {
      const phoneToUse = this.postForm.phone
      const formattedPhone = `+81${phoneToUse.substring(1)}`
      this.postForm.phone = formattedPhone

      requestForgotPassword(this.postForm).then(response => {
        showNotice(this.$t('Bao.send_phone_success'))
        this.$store.commit('SET_FORGET_OPEN', false)
        this.timerCount = true
        this.isVerify = true

        if (this.currentTimerId === null) {
          this.countDown()
        }
      }).catch((error) => {
        this.postForm.phone = phoneToUse
        showNotice(error.response.data.msg)
      })
    },
    getVerificationPop() {
      validateCodInfo({ validate_code: this.postForm.validate_code }).then(response => {
        this.isVerify = false
        this.limitVerify = true
        this.$store.commit('SET_FORGET_OPEN', false)
        this.$store.commit('SET_RESET_PASSWORD_OPEN', true)
      }).catch((error) => {
        showNotice(error.response.data.msg)
      })
    },
    handleUpdatePhone() {
      forgotPassword(this.postForm).then(response => {
        this.isUpdatePassSuccess = true
        this.limitVerify = false
      }).catch((error) => {
        showNotice(error.response.data.msg)
      })
    },
    closeVerify(status) {
      if (status === 'verify') {
        this.$store.commit('SET_FORGET_OPEN', true)
        this.isVerify = false
      } else {
        this.$store.commit('SET_RESET_PASSWORD_OPEN', false)
        this.limitVerify = false
      }

      this.initPostForm()
    },
    deactivatePopup() {
      this.initPostForm()
      this.$store.commit('SET_FORGET_OPEN', false)
    },
    updateCompleteEmail() {
      let email = null
      const { completeEmail, ...formToCheck } = this.postForm
      if (!this.hasValues(formToCheck)) {
        email = this.postForm.email
      }

      if (email && this.selectedDomain) {
        if (!email.includes('@')) {
          this.postForm.completeEmail = email + '@' + this.selectedDomain
        } else {
          this.postForm.completeEmail = email
        }
        if (this.hasValues(formToCheck)) {
          this.postForm.completeEmail = ''
        }
      } else {
        this.postForm.completeEmail = ''
      }
    },
    hasValues(form) {
      return Object.values(form).every(value => value !== null && value !== '')
    },
    onlyNumbers() {
      // 移除非數字字符
      this.postForm.phone = this.postForm.phone.replace(/\D/g, '')
    },
    changePhone() {
      this.isVerify = false
      this.postForm.phone = ''
      this.$store.commit('SET_FORGET_OPEN', true)
    },
    goHome() {
      this.limitVerify = false
      this.isUpdatePassSuccess = false
      this.$store.commit('SET_LOGIN_OPEN', true)
    },
    checkPassErrors() {
      this.passErrors = []

      if (!this.postForm.new_password) {
        this.passErrors.push(this.$t('Bao.new_password_error'))
      } else if (this.postForm.new_password && this.postForm.new_password.trim() !== '') {
        const passwordRegex = /^[a-zA-Z0-9][a-zA-Z0-9]*$/
        const hasWhitespace = /\s/

        if (hasWhitespace.test(this.postForm.new_password)) {
          this.passErrors.push(this.$t('Bao.password_restrict_chars'))
        } else if (!passwordRegex.test(this.postForm.new_password)) {
          this.passErrors.push(this.$t('Bao.password_restrict_chars'))
        } else if (this.postForm.new_password.length < 6) {
          this.passErrors.push(this.$t('Bao.password_restrict'))
        } else if (this.postForm.new_password.length > 20) {
          this.passErrors.push(this.$t('Bao.password_restrict_20'))
        }
      }
    },
    initPostForm() {
      this.postForm = {
        username: '',
        email: '',
        completeEmail: '',
        phone: '',
        validate_code: '',
        new_password: '',
        confirmPassword: ''
      }

      this.errors.clear()
    },
    countDown() {
      const timer = setInterval(() => {
        if (this.limitSecond > 0) {
          this.limitSecond--
        } else {
          this.timerCount = false
          this.limitSecond = 180
          clearInterval(timer)
          this.currentTimerId = null
        }
      }, 1000)

      this.currentTimerId = timer
    },
    getThemeImagePath
  }
}
</script>
